import React, { useState, useEffect } from 'react';
import { Button, Snackbar, Alert } from '@mui/material';

const PWAInstallPrompt: React.FC = () => {
  const [installPrompt, setInstallPrompt] = useState<any>(null);
  const [showInstallButton, setShowInstallButton] = useState(false);
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);

  useEffect(() => {
    const handleBeforeInstallPrompt = (e: Event) => {
      // Prevent the mini-infobar from appearing on mobile
      e.preventDefault();
      // Store the event so it can be triggered later
      setInstallPrompt(e);
      // Show the install button
      setShowInstallButton(true);
    };

    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

    // Check if the app is already installed
    const isAppInstalled = window.matchMedia('(display-mode: standalone)').matches;
    if (isAppInstalled) {
      setShowInstallButton(false);
    }

    return () => {
      window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
    };
  }, []);

  const handleInstallClick = () => {
    // Hide the install button
    setShowInstallButton(false);
    // Show the installation prompt
    installPrompt.prompt();
    // Wait for the user to respond to the prompt
    installPrompt.userChoice.then((choiceResult: { outcome: string }) => {
      if (choiceResult.outcome === 'accepted') {
        setShowSuccessMessage(true);
        console.log('User accepted the install prompt');
      } else {
        console.log('User dismissed the install prompt');
        setShowInstallButton(true);
      }
      // Clear the saved prompt since it can't be used again
      setInstallPrompt(null);
    });
  };

  const handleCloseSnackbar = () => {
    setShowSuccessMessage(false);
  };

  if (!showInstallButton) {
    return null;
  }

  return (
    <>
      <Button
        variant="outlined"
        color="primary"
        size="small"
        onClick={handleInstallClick}
        sx={{
          position: 'fixed',
          bottom: '20px',
          right: '20px',
          zIndex: 1000,
        }}
      >
        Install App
      </Button>
      <Snackbar 
        open={showSuccessMessage} 
        autoHideDuration={6000} 
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert onClose={handleCloseSnackbar} severity="success">
          App installed successfully!
        </Alert>
      </Snackbar>
    </>
  );
};

export default PWAInstallPrompt; 